import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Overview.styles';
import { getOverviewData } from './Overview.helpers';
import { OverviewData } from './Overview.types';
import { useAdDetails } from '@/hooks/useAdDetails';
import NoSsr from '@/components/NoSsr/NoSsr';
import { useServerDataContext } from '@/contexts';
import { Advertise } from '@/components/Ad/Promotions/Advertise';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const Overview: React.FC = () => {
  const { i18n } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;
  const overviewData = adData && getOverviewData(i18n, adData);

  const loadingData = Array.from(
    { length: 3 },
    (_, index) => ({ id: index } as OverviewData)
  );

  if (!adData) {
    return (
      <S.OverviewBox data-testid="overview-skeleton-loader">
        <S.OverviewInfoContainer>
          {loadingData.map(({ id }, index) => {
            const isLast = index === loadingData.length - 1;
            return (
              <React.Fragment key={id}>
                <SkeletonLoader height={18} width={100} borderRadius={7} />
                {!isLast && (
                  <SkeletonLoader width={4} height={4} borderRadius={2} />
                )}
              </React.Fragment>
            );
          })}
        </S.OverviewInfoContainer>

        <S.AdvertiseSkeleton />
      </S.OverviewBox>
    );
  }

  return (
    <S.OverviewBox>
      <S.OverviewInfoContainer>
        {overviewData &&
          overviewData.map(({ id, name, value, isDateTime }, index) => {
            const isLast = index === overviewData.length - 1;
            const Wrapper = isDateTime ? NoSsr : React.Fragment;
            return (
              <Wrapper key={id}>
                <S.Item>
                  {name} {value}
                </S.Item>
                {!isLast && <S.DotIcon $width={4} $height={4} />}
              </Wrapper>
            );
          })}
      </S.OverviewInfoContainer>

      <Advertise />
    </S.OverviewBox>
  );
};
